import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import { Typography } from '@mui/material';
import zpf from '../../assets/images/ZPF.svg';
import pzip from '../../assets/images/PZIP.svg';
import ftp from '../../assets/images/FTP.svg';
import opineo from '../../assets/images/opineo.svg';
import t from '../../assets/locales/pl.json';
import ImageCarousel from '../ImageCarousel/ImageCarousel';

const Logo = styled('img', { name: 'skarbonkaLogo' })(({ theme }) => ({
  height: 32,

  [theme.breakpoints.up('sm')]: {},

  [theme.breakpoints.up('md')]: {},

  [theme.breakpoints.up('lg')]: {},
}));

const LogoWrapper = styled(Box, {
  name: 'LogoWrapper',
})(({ theme }) => ({
  display: 'grid',
  width: '100%',
  marginTop: '2.4rem',
  gridTemplate: `"logo1 logo2 logo3 logo4"`,
  gap: '3.2rem',
  justifyItems: 'center',

  [theme.breakpoints.up('xs')]: {
    gridTemplate: `"logo1 logo2" 
    "logo3 logo4"`,
  },
  [theme.breakpoints.up('sm')]: {
    gridTemplate: `"logo1 logo2 logo3 logo4"`,
  },
  [theme.breakpoints.up('md')]: {},
  [theme.breakpoints.up('lg')]: {},
}));

const Footer = ({ isThankYouPage }: { isThankYouPage?: boolean }) => {
  const images = [
    'https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__480.jpg',
    'https://cdn.pixabay.com/photo/2015/12/01/20/28/road-1072823__480.jpg',
    'https://cdn.pixabay.com/photo/2015/03/26/09/47/sky-690293__480.jpg',
    'https://cdn.pixabay.com/photo/2015/11/07/11/34/landscape-1031933__480.jpg',
    'https://cdn.pixabay.com/photo/2017/08/30/01/05/milky-way-2695569__480.jpg',
    'https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__480.jpg',
    'https://cdn.pixabay.com/photo/2015/12/01/20/28/road-1072823__480.jpg',
    'https://cdn.pixabay.com/photo/2015/11/07/11/34/landscape-1031933__480.jpg',
    'https://cdn.pixabay.com/photo/2017/08/30/01/05/milky-way-2695569__480.jpg',
    'https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__480.jpg',
    'https://cdn.pixabay.com/photo/2015/03/26/09/47/sky-690293__480.jpg',
    'https://cdn.pixabay.com/photo/2015/11/07/11/34/landscape-1031933__480.jpg',
    'https://cdn.pixabay.com/photo/2017/08/30/01/05/milky-way-2695569__480.jpg',
  ];

  return (
    <Box
      sx={() => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        // maxWidth: '64rem',
        padding: '1.6rem',
        mb: '3rem',
      })}
    >
      {isThankYouPage && (
        <Typography
          fontSize={22}
          fontWeight={700}
          sx={{ gridArea: 'header', margin: '1.6rem 0', textAlign: 'center' }}
        >
          {t.footerTitle}
        </Typography>
      )}
      {/* <ImageCarousel images={images} /> */}

      <LogoWrapper>
        <Logo src={zpf} style={{ gridArea: 'logo1' }} />
        <Logo src={pzip} style={{ gridArea: 'logo2' }} />
        <Logo src={ftp} style={{ gridArea: 'logo3' }} />
        <Logo src={opineo} style={{ gridArea: 'logo4' }} />
      </LogoWrapper>
    </Box>
  );
};

export default Footer;
